<template>
  <el-card>
    <div slot="header" class="toolbar">
      <span>模块配置</span>
      <el-button size="mini" @click="load">刷新</el-button>
    </div>

    <div class="search-bar search-wrap">
      <el-input
        v-model.trim="query.moduleName"
        placeholder="请输入模块名称"
        clearable
        style="width: 220px"
        @keyup.enter.native="handleSearch"
      />
      <el-select v-model="query.showStatus" clearable placeholder="展示状态" style="width: 140px">
        <el-option :value="1" label="展示" />
        <el-option :value="0" label="隐藏" />
      </el-select>
      <el-button type="primary" @click="handleSearch">查询</el-button>
      <el-button @click="reset">重置</el-button>
    </div>

    <el-table :data="list" border style="width: 100%">
      <el-table-column prop="id" label="编号" width="90" />
      <el-table-column prop="moduleName" label="模块名称" min-width="140" />
      <el-table-column prop="moduleCode" label="模块编码" min-width="160" />
      <el-table-column prop="showStatus" label="是否展示" width="120">
        <template slot-scope="{ row }">
          <el-tag :type="row.showStatus === 1 ? 'success' : 'info'" size="mini">
            {{ row.showStatus === 1 ? '展示' : '隐藏' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="sortNum" label="排序" width="90" />
      <el-table-column prop="remark" label="备注" min-width="220" show-overflow-tooltip />
      <el-table-column prop="updateTime" label="更新时间" width="180" />
      <el-table-column label="操作" width="180" fixed="right">
        <template slot-scope="{ row }">
          <el-button v-if="$hasPermission('mall:home-module:update')" size="mini" @click="openEdit(row)">编辑</el-button>
          <el-button
            v-if="$hasPermission('mall:home-module:update')"
            :type="row.showStatus === 1 ? 'warning' : 'success'"
            size="mini"
            @click="toggleStatus(row)"
          >
            {{ row.showStatus === 1 ? '隐藏' : '展示' }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-bar">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="query.page"
        :page-size="query.limit"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </div>

    <el-dialog title="编辑模块配置" :visible.sync="dialogVisible" width="560px" :close-on-click-modal="false">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="90px">
        <el-form-item label="模块名称">
          <el-input v-model="form.moduleName" disabled />
        </el-form-item>
        <el-form-item label="模块编码">
          <el-input v-model="form.moduleCode" disabled />
        </el-form-item>
        <el-form-item label="是否展示">
          <el-radio-group v-model="form.showStatus">
            <el-radio :label="1">展示</el-radio>
            <el-radio :label="0">隐藏</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序" prop="sortNum">
          <el-input-number v-model="form.sortNum" :min="0" :precision="0" style="width: 100%" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model.trim="form.remark" type="textarea" :rows="3" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button v-if="$hasPermission('mall:home-module:update')" type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import http from '../../utils/http'

function defaultQuery () {
  return {
    page: 1,
    limit: 10,
    moduleName: '',
    showStatus: null
  }
}

function defaultForm () {
  return {
    id: null,
    moduleCode: '',
    moduleName: '',
    showStatus: 1,
    sortNum: 0,
    remark: ''
  }
}

export default {
  data () {
    return {
      query: defaultQuery(),
      total: 0,
      list: [],
      dialogVisible: false,
      form: defaultForm(),
      rules: {
        sortNum: [{ required: true, message: '请输入排序', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      const { data } = await http.get('/mall/home-module/list', { params: this.query })
      const pageData = data.data || {}
      this.list = pageData.list || []
      this.total = Number(pageData.total || 0)
    },
    handleSearch () {
      this.query.page = 1
      this.load()
    },
    handlePageChange (page) {
      this.query.page = page
      this.load()
    },
    handleSizeChange (limit) {
      this.query.limit = limit
      this.query.page = 1
      this.load()
    },
    reset () {
      this.query = defaultQuery()
      this.load()
    },
    async openEdit (row) {
      const { data } = await http.get(`/mall/home-module/info/${row.id}`)
      const info = data.data || {}
      this.form = {
        id: info.id,
        moduleCode: info.moduleCode || '',
        moduleName: info.moduleName || '',
        showStatus: Number(info.showStatus == null ? 1 : info.showStatus),
        sortNum: Number(info.sortNum || 0),
        remark: info.remark || ''
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
    },
    toggleStatus (row) {
      const nextStatus = row.showStatus === 1 ? 0 : 1
      const actionText = nextStatus === 1 ? '展示' : '隐藏'
      this.$confirm(`确定${actionText}模块“${row.moduleName}”吗？`, '提示', { type: 'warning' }).then(async () => {
        const { data } = await http.post('/mall/home-module/status', {
          id: row.id,
          showStatus: nextStatus
        })
        if (data.code === 0) {
          this.$message.success(`模块已${actionText}`)
          this.load()
        }
      })
    },
    save () {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        const { data } = await http.post('/mall/home-module/update', {
          id: this.form.id,
          showStatus: this.form.showStatus,
          sortNum: Number(this.form.sortNum || 0),
          remark: this.form.remark
        })
        if (data.code === 0) {
          this.$message.success('模块配置保存成功')
          this.dialogVisible = false
          this.load()
        }
      })
    }
  }
}
</script>

<style scoped>
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.search-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.search-wrap {
  flex-wrap: wrap;
}

.pagination-bar {
  margin-top: 12px;
  text-align: right;
}
</style>
